export const fadeInFromBelow = ({
    inView
}: {
    inView: boolean;
}): {
    config: { mass: 5; tension: 750; friction: 200 };
    opacity: 1 | 0;
    marginTop: 0 | 100;
    from: { opacity: 0; marginTop: 100 };
} => {
    return {
        config: { mass: 5, tension: 750, friction: 200 },
        opacity: inView ? 1 : 0,
        marginTop: inView ? 0 : 100,
        from: { opacity: 0, marginTop: 100 }
    };
};
